<template>
    <div class="login">
        <img v-if="seller.logo" :src="getImgUrl(seller.logo)" alt="logo" style="display: block;margin: 10% auto;max-width: 128px;"  />
            <!-- <img v-if="seller.bannerImage" :src="getImgUrl(seller.bannerImage)" alt="banner" style="width: 100%;max-height: 260px;" /> -->
            <div v-if="seller.logo==null" style="height: 180px;text-align: center;line-height: 180px;font-size: 16px;font-weight: 600;">{{ seller.restaurantName }}</div>
          
        <div class="indexLogin">
           <mu-form ref="form" :model="tableOrderInfo" class="mu-demo-form">
                <mu-form-item :label="$t('login.name')" prop="name" :rules="usernameRules">
                    <mu-text-field v-model="tableOrderInfo.name" prop="name"></mu-text-field>
                </mu-form-item>

                <mu-form-item :label="$t('login.telephone')" prop="telephone" :rules="phoneRules">
                    <mu-text-field v-model="tableOrderInfo.telephone" prop="telephone"></mu-text-field>
                </mu-form-item>

                <!--<mu-form-item label="Number" prop="Voksne">
                <mu-select label="" v-model="tableOrderInfo.Voksne" full-width>
                    <mu-option v-for="option,index in options" :key="option" :label="option" :value="option"></mu-option>
                </mu-select>

                <mu-text-field v-model="tableOrderInfo.Voksne" prop="Voksne"></mu-text-field>
            </mu-form-item>-->
               <mu-form-item>
                    <mu-checkbox v-model="chkSendSms" value="1" :label="chkTxt"></mu-checkbox>
                </mu-form-item>
                <mu-form-item style="margin:auto;text-align:center;">
                    <mu-button color="primary" large full-width @click="enterOrder" style="background-color:#da5b3a;width:94%;text-transform: unset;">
                        {{$t('login.begin')}}
                    </mu-button>
                    <mu-button  color="#ccc" v-if="tableOrderInfo.orderType!=2" large full-width style="width:94%;text-transform: unset;" @click="anonymousEnter">  {{$t('login.anonymous')}}</mu-button>
                </mu-form-item>
            </mu-form>
        </div>
        <div style="position:absolute;top:10px;right:-75px;z-index:1000">
            <mu-menu cover>
                <mu-button fab small color="success" style="position:absolute;right:88px;" >
                    {{getLanage()}}
                </mu-button>
                <mu-list slot="content">
                    <mu-list-item button @click="selectLanage('DK')">
                        <mu-list-item-title>DK</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('EN')">
                        <mu-list-item-title>EN</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('PT')">
                        <mu-list-item-title>PT</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('中文')">
                        <mu-list-item-title>中文</mu-list-item-title>
                    </mu-list-item>
                </mu-list>
            </mu-menu>
        </div>
    
    </div>
</template>

<script>
    import { formatDate } from '../utils/formatDate'
    import preventBack from 'vue-prevent-browser-back';
    export default {
        mixins: [preventBack],//注入  阻止返回上一页
        data() {
        return {
            usernameRules: [
                { validate: (val) => !!val, message: this.$t("login.nameNotNull") }
            ],
            phoneRules: [
                { validate: (val) => !!val, message: this.$t("login.phoneNotNull") }
            ],
            seller: {},
            styleChange: {

            },
            configsData:{},
            chkSendSms:true,
            chkTxt:"Agree to send SMS",
            tableOrderInfo: {
                name: '',
                tableName: '',
                orderType:1,
                restaurantId:0,
                telephone: '',
                number: 0,
                specielle: '',
                isSendSms:1
            },
            options: [
                '1', '2', '3', '4',
                '5', '6', '7', '8',
                '9', '10', '11', '12', '13', '14',
                '15', '16', '17', '18',
                '19', '20'
            ],
            fullscreen: false,
        }
        },
        created() {
            
        },
        mounted() {
            this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
            this.tableOrderInfo.tableName = this.$route.query.tableName;
            this.tableOrderInfo.orderType = this.$route.query.orderType;
            this.getRestaurantInfo();
        },
        methods: {
            async getConfigs() {
                await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                            this.chkTxt=this.configsData.SendSMSTip;
                        }
                    });
            },
            getRestaurantInfo() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeBasicInfo/GetRestaurant', param)
                    .then(response => {
                        if (response.code == 200) {
                            let data=response.data;
                            this.seller = data;
                            this.getConfigs();
                            let img = new Image()
                            img.src = this.getImgUrl(data.logo)
                            let that=this;
                            that.styleChange = {
                                        width: '100px',
                                        height: '100px',
                                        display: 'block',
                                        margin: '10% auto'
                                    } 
                            setTimeout(() => {
                                if (img.width == img.height) {
                                    that.styleChange = {
                                        width: '100px',
                                        height: '100px',
                                        display: 'block',
                                        margin: '10% auto'
                                    }        
                                }
                                else {
                                    that.styleChange = {
                                        width: '128px',
                                        height: '96px',
                                        display: 'block',
                                        margin: '10% auto'
                                    }
                            }},2000)
                                
                            
                            localStorage.setItem('lang',this.seller.language);
                            this.getLanage();
                            window.localStorage.setItem('seller', JSON.stringify(this.seller));
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            getLanage() {
                if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                    this.$i18n.locale = localStorage.getItem('lang');
                    return localStorage.getItem('lang');
                }
                this.$i18n.locale = this.seller.language;
                return this.seller.language;
            },
            selectLanage(lng) {
                this.$i18n.locale = lng;
                localStorage.setItem('lang', lng);
            },
            getImgUrl(image) {
                if (image == undefined || image == 'undefined') {
                    return null;
                }
                return this.imageBaseUrl + image;
            },
            anonymousEnter() {
                this.tableOrderInfo.name = 'guest';
                this.tableOrderInfo.telephone = '00000000';
                this.enterOrder();
            },
      enterOrder() {
     
      },
      handleFullScreen(){
        let element = document.documentElement;
        if (this.fullscreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullscreen();
            }
        }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .login {
        position: fixed;
        top: 0;
        bottom: 0;
        width: 100%;
        background-color:#fff;
    }
  .logo {
    width: 128px;
    height: 96px;
    display: block;
    margin: 10% auto;
  }
  .indexLogin {
    padding: 0 24px;
    height:100%;
    padding-top:30px;
  }

    
</style>



// WEBPACK FOOTER //
// src/components/LoginShow.vue